<template>
    <div class="ar-button">
        AR
        <div class="ar-button-icon-container">
            <span class="icon-view_in_ar"></span>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: "ARButton"
};
</script>

<style scoped>
.ar-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--white);
    font-weight: 500;
}

.ar-button-icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 2em;
    background-color: rgba(100, 100, 100, 0.5);
    margin-top: 3px;
    padding: 10px;
    border-radius: 50%;
}
</style>
